module.exports = __webpack_public_path__ + "img/logo.6844fa29.svg";